import React from "react";
import ReactPaginate from "react-paginate";

const Pagination = ({
  data,
  pageChangeHandler,
  usersPerPage,
  currentPage,
  searchValue = "",
  searchedDataPageCounts,
}) => {
  const pageCount = Math.ceil(data?.length / usersPerPage);

  console.log(pageCount, "pageCount");


  const searchedPageCounts = Math.ceil(
    searchedDataPageCounts?.length / usersPerPage
  );

  return (
    <div
      className="row mt-7"
      style={{
        position: "absolute",
        bottom: "5px",
        right: "25px",
      }}
    >
      <div className="col-lg-12">
        <ReactPaginate
          previousLabel={currentPage === 0 ? null : "Previous"}
          nextLabel={currentPage === pageCount - 1 ? "" : "Next"}
          pageCount={searchValue === "" ? pageCount : searchedPageCounts}
          onPageChange={pageChangeHandler}
          containerClassName={"paginationBttns"}
          previousClassName={currentPage === 0 ? "hidden" : "previousBttn"}
          nextClassName={currentPage === pageCount - 1 ? "d-none" : "nextBttn"}
          disabledClassName={"paginationDisabled"}
          activeClassName={"paginationActive"}
          forcePage={currentPage}
        />
      </div>
    </div>
  );
};

export default Pagination;
